/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT } from 'cio/services/event-bus';
import { action } from '@ember/object';

@tagName('')
export default class DeleteButton extends Component {
  @service eventBus;

  actionAbstract = null;
  deleteTask = null;
  isSaving = false;
  hasReadOnlyPermission = false;

  didInsertElement() {
    super.didInsertElement(...arguments);

    this.eventBus.subscribe(VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT, this, this.onInitiateDelete);
  }

  willDestroy() {
    super.willDestroy();

    this.eventBus.unsubscribe(VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT, this, this.onInitiateDelete);
  }

  @action
  onInitiateDelete() {
    if (this.isSaving || this.hasReadOnlyPermission) {
      return;
    }

    this.deleteTask?.perform();
  }
}
